"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RinkebyWrappedToken = exports.RinkebyNativeToken = void 0;
const utils_1 = require("@unifiprotocol/utils");
exports.RinkebyNativeToken = new utils_1.Currency("ETH", 18, "ETH", "Ethereum");
exports.RinkebyWrappedToken = new utils_1.Currency("0xdf032bc4b9dc2782bb09352007d4c57b75160b15", 18, "WETH", "Wrapped ETH");
